import { eCDV3ItemTypes } from '../../enums/eCDV3ItemTypes';

type TViewItemWithSubType = {
  type: eCDV3ItemTypes;
  sub_type?: any;
};

function itemThatMatches(itemToFind: TViewItemWithSubType) {
  return (item: TViewItemWithSubType) => {
    const isTheSameType = itemToFind.type === item.type;
    const isSubTypeProvided = !!itemToFind.sub_type && !!item.sub_type;
    const isSubTypeSame = itemToFind.sub_type === item.sub_type;
    return isTheSameType && (isSubTypeProvided ? isSubTypeSame : true);
  };
}

export const removeDuplicateDefaultViewItems = (items: TViewItemWithSubType[]) => (defaultItem: TViewItemWithSubType) =>
  !items.find(itemThatMatches(defaultItem));
